/**
 * An employee number in a portal table, as a way into that person's Employee Lifeline.
 * The link carries the server's OPAQUE reference (`employeeRef`), never the number: the
 * number is only the text shown. Rendered as a link-styled button only when the caller
 * passes `onOpenEmployee` (the portal does, for viewers holding view_employee_detail) and
 * the row has a reference; otherwise the plain number.
 */
import './Lifeline.css'

export default function EmployeeCell({ number, employeeRef = null, onOpenEmployee = null }) {
  const text = number != null && number !== '' ? String(number) : null
  if (!text) return <>—</>
  if (!onOpenEmployee || !employeeRef) return <>{text}</>
  return (
    <button
      type="button"
      className="ll-emp-link"
      aria-label={`Open the lifeline of employee ${text}`}
      onClick={(e) => { e.stopPropagation(); onOpenEmployee(employeeRef) }}
    >
      {text}
    </button>
  )
}
